import React, { MouseEvent, useState } from 'react';
import AccordionItem from './AccordionItem';
import styles from './App.module.css';

import { ReactComponent as IllustrationBox } from './assets/illustration-box.svg';
import { ReactComponent as IllustrationMobile } from './assets/illustration-woman-online-mobile.svg';

const accordionItems = [
  {
    id: 1,
    title: 'How many team members can I invite?',
    body: 'You can invite up to 2 additional users on the Free plan. There is no limit on team members for the Premium plan.'
  }, {
    id: 2,
    title: 'What is the maximum file upload size?',
    body: 'No more than 2GB. All files in your account must fit your allotted storage space.'
  }, {
    id: 3,
    title: 'How do I reset my password?',
    body: 'Click “Forgot password” from the login page or “Change password” from your profile page. A reset link will be emailed to you.'
  }, {
    id: 4,
    title: 'Can I cancel my subscription?',
    body: 'Yes! Send us a message and we’ll process your request no questions asked.'
  }, {
    id: 5,
    title: 'Do you provide additional support?',
    body: 'Chat and email support is available 24/7. Phone lines are open during normal business hours.'
  }
];


function App() {

  const [currId, setCurrId] = useState(-1);

  const onClickHandler = (id: number) => (event: MouseEvent) => {
    setCurrId(id);
  };

  return (
    <div className={styles['app']}>
      <div className={styles['card']}>
        <div className={styles['box']}>
          <IllustrationBox />
        </div>
        <div className={styles['mobile']}>
          <IllustrationMobile />
        </div>
        <div className={styles['content']}>
          <h1>FAQ</h1>
          <div className={styles['accordion']}>
            {accordionItems.map(item => <AccordionItem data={item} active={item.id === currId} onClickHandler={onClickHandler(item.id)} />)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
